import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'formatHoursInDays'
  })
  export class FormatHoursInDaysPipe implements PipeTransform {

    transform(value: any, args?: any): any {
      let timeString = '';
      const days = Math.floor(value / (Number(args) * 60));
      const hours = Math.floor((value % (Number(args) * 60)) / 60);
      const min = (value % (Number(args) * 60) ) % 60;

      timeString = `${ days ? days + 'd ' : '' }${ hours ? hours + 'h ' : days ? '0h ' : '' }${ min ? min + 'm' : '0m' }`;

      return timeString;
    }

  }
